import Ajv from "ajv";
import schema from "./schema.json";

const ajv = new Ajv();

export function validate(value) {
  const result = ajv.validate(schema, value);

  if (!result) {
    return ajv.errors;
  }

  return null;
}
